var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompanyAgencyAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 34C27.732 34 34 30.866 34 27C34 23.134 27.732 20 20 20C12.268 20 6 23.134 6 27C6 30.866 12.268 34 20 34Z",
    fill: "#FDAB29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 33.5C27.4558 33.5 33.5 30.5899 33.5 27C33.5 23.4101 27.4558 20.5 20 20.5C12.5442 20.5 6.5 23.4101 6.5 27C6.5 30.5899 12.5442 33.5 20 33.5Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24C25.5228 24 30 19.5228 30 14C30 8.47715 25.5228 4 20 4C14.4772 4 10 8.47715 10 14C10 19.5228 14.4772 24 20 24Z",
    fill: "#FDAB29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.5C25.2467 23.5 29.5 19.2467 29.5 14C29.5 8.75329 25.2467 4.5 20 4.5C14.7533 4.5 10.5 8.75329 10.5 14C10.5 19.2467 14.7533 23.5 20 23.5Z",
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyAgencyAccount);
export default __webpack_public_path__ + "static/media/company_agency-account.fc9216c52ba642237f5dd1900b98102f.svg";
export { ForwardRef as ReactComponent };